// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1YyZG","boxTitle":"Qualiphy_boxTitle__3qCBA","box":"Qualiphy_box__32cr1","toggleWrap":"Qualiphy_toggleWrap__2VVhq"};